function initialiseScrollLink() {
  $('#hero-scroll-link').on('click', function() {
    var viewportHeight = $(window).height();
    var headerheight = 69;

    $('html, body').animate({
      scrollTop: viewportHeight - headerheight,
    }, 500);
  });
}

function initialiseMarquee() {
  var marqueeContainer = $('.marquee');

  if (marqueeContainer.length == 0) {
    return;
  }

  var marqueeTextParagraph = $('.marquee__text p');
  var marqueeContent = $('.marquee__content');

  $('body').addClass('with-marquee');

  var containerWidth = marqueeContainer.width();
  var textWidth = marqueeTextParagraph.width() + 20;

  var repeats = Math.ceil(containerWidth / textWidth) + 2;

  marqueeContent.empty();

  for (var i = 0; i < repeats; i += 1) {
    marqueeContent.append('<span class="marquee__text">' + marqueeTextParagraph.html() + '</span>');
  };

  var transformX = 0;

  setInterval(function() {
    transformX += 0.4;

    if (transformX > textWidth) {
      transformX = 0;
    }

    marqueeContent.css('transform', 'translateX(-' + transformX + 'px)');
  }, 20);
}

function initialiseLogosMarquee() {
  var trackContainer = $('.logo-bar__track');

  var unniqueLogosWidth = 0;

  var itemsContainer = $('.logo-bar__items');
  var itemsList = $('.logo-bar__item');

  itemsList.each((_, item) => {
    unniqueLogosWidth += $(item).width() + 70;
  });

  var desiredWidth = trackContainer.width() + unniqueLogosWidth + 20;
  var currentWidth = unniqueLogosWidth;
  var itemsIndex = 0;

  while (currentWidth < desiredWidth) {
    var itemToAdd = itemsList[itemsIndex];

    itemsContainer.append($(itemToAdd).clone());

    if (itemsIndex < itemsList.length - 1) {
      itemsIndex++;
    } else {
      itemsIndex = 0;
    }
    
    currentWidth += $(itemToAdd).width() + 70;
  }

  var transformX = 0;

  setInterval(function() {
    transformX += 1;

    if (transformX > unniqueLogosWidth) {
      transformX = 0;
    }

    itemsContainer.css('transform', 'translateX(-' + transformX + 'px)');
  }, 20);
}

function initialiseHeroParallax() {
  var wdw = $(window);
  var imageContainer = $('.hero__banner-image-container');

  $(wdw).on('scroll', function() {
    var transform = 0.5 * wdw.scrollTop();

    imageContainer.css('transform', 'translateY(' + transform + 'px)');
  });
}

function timeoutFunction(i, values) {
  var value = values[i];
  $(value).addClass('animate');
};

function initialiseValuesLines() {
  var values = $('.values');
  var wdw = $(window);
  var valuesBottom = values.position().top + values.height();
  var classAdded = false;

  wdw.on('scroll', function() {
    var scrollBottom = wdw.scrollTop();
    if (!classAdded && scrollBottom > valuesBottom) {
      classAdded = true;
      var values = $('.values .value');
      for (var i = 0; i < values.length; i += 1) {
        setTimeout(timeoutFunction.bind(null, i, values), i * 200);
      }
    }
  });
}

function createInstaSlider() {
  var sliderContainer = $('#insta-feed');
  var leftArrow = $('#insta-feed-wrapper-carousel-left');
  var rightArrow = $('#insta-feed-wrapper-carousel-right');

  sliderContainer.slick({
    slide: 'a',
    arrows: true,
    dots: false,
    vertical: false,
    verticalSwiping: false,
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    slidesToScroll: 2,
    swipeToSlide: true,
    infinite: false,
    initialSlide: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '20px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  sliderContainer.on('afterChange', function(_, slick, currentSlide) {
    new Promise((resolve) => {
      if (currentSlide === 0) {
        leftArrow.addClass('disabled');
      } else {
        leftArrow.removeClass('disabled');
      }
      
      if (currentSlide === slick.slideCount - 1) {
        rightArrow.addClass('disabled');
      } else {
        rightArrow.removeClass('disabled');
      }
      resolve();
    })
  })

  leftArrow.on('click', function() {
    sliderContainer.slick('slickPrev');
  });

  rightArrow.on('click', function() {
    sliderContainer.slick('slickNext');
  });
}

function initialiseInstaSlider() {
  var intervalId = setInterval(function() {
    if ($('#insta-feed .instafeed-container').length > 0) {
      createInstaSlider();
      clearInterval(intervalId);
    }
  }, 500);
}

function initialiseFavourites(vw) {
  if (vw > 992) {
    return;
  }

  var sliderContainer = $($('.favourites__products-container')[0]);
  var leftArrow = $('#favourites-carousel-left');
  var rightArrow = $('#favourites-carousel-right');

  initialiseSlickWithArrows(sliderContainer, leftArrow, rightArrow);
}

function initialiseSlickWithArrows(sliderContainer, leftArrow, rightArrow) {
  sliderContainer.slick({
    arrows: false,
    dots: false,
    vertical: false,
    verticalSwiping: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
  });
  
  sliderContainer.on('afterChange', function(_, slick, currentSlide) {
    new Promise((resolve) => {
      if (currentSlide === 0) {
        leftArrow.addClass('disabled');
      } else {
        leftArrow.removeClass('disabled');
      }
      
      if (currentSlide === slick.slideCount - 1) {
        rightArrow.addClass('disabled');
      } else {
        rightArrow.removeClass('disabled');
      }
      resolve();
    });
  });

  leftArrow.on('click', function() {
    sliderContainer.slick('slickPrev');
  });

  rightArrow.on('click', function() {
    sliderContainer.slick('slickNext');
  });
}

function main() {
  var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  initialiseScrollLink();
  initialiseMarquee();
  initialiseLogosMarquee();
  initialiseHeroParallax();
  initialiseValuesLines();
  initialiseFavourites(vw);
  initialiseInstaSlider();
  const feed = new Instafeed({
    accessToken: 'TON_TOKEN_D_ACCES',
    limit: 6,
    template: '<a href="{{link}}" target="_blank"><img title="{{caption}}" src="{{image}}" /></a>'
  });
  feed.run();
}

$('document').ready(main);